import { createContext } from 'react';
import { TabsNavProps } from './TabsNav';

type TabsNavContextValue = {
	variant?: TabsNavProps['variant'];
};

export const TabsNavContext = createContext<TabsNavContextValue>({});
